// 默认错误提示
const errorMessages = {
    'email': '格式错误,请输入6-16位字母、数字、下划线组成，并以字母开头的账号',
    'password': '格式错误,密码需为8-16位字母数字组合，可含特殊字符',
    'mobile': '请输入正确的手机号',
    'mail': '请输入正确的邮箱'
}
const validations = {
    nonEmpty: (ruleValue, vaForm, va) => {
        return !!vaForm.dom.value.trim()
    },
    reg: (ruleValue, vaForm, va) => {
        return !!ruleValue.test(vaForm.dom.value.trim())
    },
    limit: (ruleValue, vaForm, va) => {
        var value = vaForm.dom.value.trim()
        return !!(((+value >= ruleValue[0]) && (+value <= ruleValue[1])))
    },
    equal: (ruleValue, vaForm, validator) => {
        var target = validator.forms[ruleValue]
        return target.value.trim() === vaForm.dom.value.trim()
    },
    length: (ruleValue, vaForm, va) => {
        var length = vaForm.dom.value.length
        return !!(((+length >= ruleValue[0]) && (+length <= ruleValue[1])))
    }
}
// 常用正则表
export const regList = {
    imgcode: /^[0-9a-zA-Z]{4}$/,
    smscode: /^\d{4}$/,
    email: /^[a-zA-Z][\w\d]{5,15}$/,
    password: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d`~!@#$%^&*()_+-={}\[\]\|<>\?:;\',\"\.\/\\*]{8,16}$/,
    mobile: /^1\d{10}$/,
    realName: /^[\u4e00-\u9fa5|·]{2,20}$|^[a-zA-Z|\s]{2,20}$/,
    bankNum: /^\d{10,19}$/,
    money: /^([1-9]\d*|[0-9]\d*\.\d{1,2}|0)$/,
    answer: /^\S+$/,
    mail: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
    idCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
}
// Rule构造器
function Rule (ruleType, ruleValue, errMsg) {
    this.ruleType = ruleType
    this.ruleValue = ruleValue
    this.errMsg = errMsg || ''
}
function VaForm (el, rules, modifiers) {
    this.ruleOrder = []
    this.rules = {}
    this.dom = el
    this.errorTag = ''
    this.value = el.value
    this.ischecked = false
    this.tag = el.getAttribute('tag') // 提示的字段名
    this.modifiers = modifiers
    this.noCheck = false // 为true则不要校验

    this.ruleOrder = rules.map(item => {
        this.rules[item.ruleType] = item
        return item.ruleType
    })
}

function getErrMsg (vaForm, ruleType, ruleValue) {
    var tag = vaForm.tag
    var errMsgs = {
        nonEmpty: `${tag}不能为空`,
        reg: `${tag}格式错误`,
        limit: `${tag}必须在${ruleValue[0]}与${ruleValue[1]}之间`,
        equal: `两次${tag}不相同`,
        length: `${tag}长度必须在${ruleValue[0]}与${ruleValue[1]}之间`,
        unique: `${tag}不能相同`
    }
    return errMsgs[ruleType]
}

function checkRule (vaForm, rule) {
    var {ruleType, ruleValue, errMsg} = rule
    errMsg = errMsg || getErrMsg(vaForm, ruleType, ruleValue)
    var isPass = validations[ruleType](ruleValue, vaForm, this)
    return {
        ruleType: ruleType,
        ruleValue: ruleValue,
        isPass: isPass,
        errMsg: isPass ? null : errMsg
    }
}

function checkForm (vaForm) {
    var results = vaForm.ruleOrder.map(ruleType => {
        let rule = vaForm.rules[ruleType]
        return this.checkRule(vaForm, rule)
    })

    var errIndex = null
    for (var i = 0; i < results.length; i++) {
        var result = results[i]
        if (result.isPass === false) {
            errIndex = i
            break
        }
    }
    return {
        isPass: errIndex === null,
        message: (results[errIndex] && results[errIndex].errMsg) || ''
    }
}
function validate (field) {
    let fieldForm = this.forms[field]
    let result = this.checkForm(fieldForm)
    let $msgInfo = fieldForm.dom.parentElement.querySelector('.msg-info')
    this.vmResult[field] = result
    fieldForm.ischecked = true
    if (fieldForm.errorTag) {
        fieldForm.errorTag.innerHTML = result.message
        fieldForm.errorTag.classList.remove('dn')
    }
    $msgInfo && $msgInfo.classList.add('dn')
    return result
}
function validateSome (arr) {
    var submitFlag = true
    arr.forEach(field => {
        var vaForm = this.forms[field]
        if (vaForm) {
            var canNull = vaForm.ruleOrder.every(ruleType => ruleType !== 'nonEmpty')
            var noCheckEmpty = (vaForm.dom.value.trim() === '' && canNull)
            if (vaForm.noCheck === false && noCheckEmpty === false) {
                if (!vaForm.ischecked) {
                    this.validate(field)
                }
                if (!this.vmResult[field].isPass) {
                    submitFlag = false
                }
            }
        }
    })
    return Promise.resolve(submitFlag)
}
function validateAll () {
    var submitFlag = true
    this.fieldOrder.forEach(field => {
        var vaForm = this.forms[field]
        var canNull = vaForm.ruleOrder.every(ruleType => ruleType !== 'nonEmpty')
        var noCheckEmpty = (vaForm.dom.value.trim() === '' && canNull)

        if (vaForm.noCheck === false && noCheckEmpty === false) {
            if (!vaForm.ischecked) {
                this.validate(field)
            }
            if (!this.vmResult[field].isPass) {
                submitFlag = false
            }
        }
    })
    return Promise.resolve(submitFlag)
}

function resetForms () {
    this.vmResult = {}
    this.fieldOrder = []
    this.errorTags = {}
    this.equalObj = {}
    this.forms = {}
}

let ValidatorLite = {}
ValidatorLite.install = function (Vue, options) {
    var validator = {
        vmResult: {},
        errorTags: {},
        fieldOrder: [],
        forms: {},
        equalObj: {},
        Rule: Rule,
        VaForm: VaForm,
        validate: validate,
        checkRule: checkRule,
        checkForm: checkForm,
        validateAll: validateAll, // 检查所有的函数
        validateSome: validateSome,
        resetForms: resetForms
    }
    Vue.mixin({
        computed: {
            $validator () {
                return validator
            }
        }
    })
    Vue.directive('validates', {
        bind (el, binding, vnode, oldVnode) {
            var field = el.getAttribute('name')
            var option = binding.modifiers // 校验配置
            var regMsg = el.getAttribute('regMsg') || errorMessages[field] || ''
            var optionalRule = []
            validator.fieldOrder.push(field) // 字段的检验顺序
            var nonEmpty = new Rule('nonEmpty', true, '')
            // 默认非空
            if (option.CanNull === undefined) {
                optionalRule.push(nonEmpty)
            }
            var regOptions = Object.keys(option)
            for (var i = 0; i < regOptions.length; i++) {
                var regOption = regOptions[i]
                if (regList[regOptions[i]]) {
                    optionalRule.push(new Rule('reg', regList[regOption], regMsg))
                }
            }
            if (binding.value !== undefined) {
                binding.value.map(item => {
                    let ruleType = Object.keys(item)[0]
                    let ruleValue = item[ruleType]
                    let errMsg = ruleType === 'reg' ? regMsg : ''
                    optionalRule.push(new Rule(ruleType, ruleValue, errMsg))
                    if (ruleType === 'equal') {
                        if (validator.equalObj[ruleValue] === undefined) {
                            validator.equalObj[ruleValue] = [field]
                        } else {
                            validator.equalObj[ruleValue].push(field)
                        }
                    }
                })
            }
            var vaForm = new VaForm(el, optionalRule, option)
            validator.forms[field] = vaForm
            el.onblur = function () {
                validator.forms[field].value = el.value.trim()
                // 如果允许为空的此时为空，不校验
                if (vaForm.dom.value.trim() === '' && option.CanNull) {
                    validator.vmResult[field] = {}
                    return
                }

                if (vaForm.noCheck === false) {
                    validator.validate(field)
                }

                for (var index in validator.equalObj) {
                    if (index === field) {
                        validator.equalObj[field].forEach(item => {
                            validator.forms[item].ischecked && validator.validate(item)
                        })
                    }
                }
            }
            el.onfocus = function () {
                validator.forms[binding.arg].errorTag && validator.forms[binding.arg].errorTag.classList.add('dn')
                el.parentElement.querySelector('.msg-info') && el.parentElement.querySelector('.msg-info').classList.remove('dn')
            }
        },
        unbind (el, binding, vnode, oldVnode) {
            // var field = el.getAttribute('name')
            // validator.fieldOrder.remove(field)
            // delete validator.forms[field]
            // delete validator.vmResult[field]
            // delete validator.equalObj[field]
        }
    })
    Vue.directive('validate-error', {
        bind (el, binding, vnode, oldVnode) {
            // 申诉回退的时候先执行了这个，why
            setTimeout(() => {
                validator.errorTags[binding.arg] = el
                validator.forms[binding.arg] && (validator.forms[binding.arg].errorTag = el)
            }, 0)
        },
        unbind (el, binding, vnode, oldVnode) {
            // delete validator.errorTags[binding.arg]
            el.innerHTML = ''
        }
    })
}

export default ValidatorLite



// WEBPACK FOOTER //
// ./src/plugin/validate.js